import useMediaQuery from '@utils/hooks/useMediaQuery';

export const IsMobile = () => {
  const isMobile = useMediaQuery('(max-width: 767.98px)');
  return isMobile;
};
